import React from 'react'
import alcogelicon from '../../../images/covidIcons/Sanitizer.png'
import handwashicon from '../../../images/covidIcons/Gloves.png'
import maskicon from '../../../images/covidIcons/Mask.png'

function CovidGuideLines() {
  return (
    <div className="text-center mx-auto place-content-center mt-10 mb-64 sm:mb-20">
      <h1 className="text-primary font-semibold text-2xl sm:text-4xl mx-auto mb-4 sm:mb-8">
        Covid-19 Guidelines
      </h1>
      <p className="text-gray-500 sm:text-lg mb-8 mx-4 sm:mx-32">
        In light of the Covid-19 pandemic, all XiViX partners & staff follow
        strict Covid-19 Guidelines. Visit your nearest Digital Dentist for a
        safe and pleasent dental experience.
      </p>
      <div className="flex justify-center gap-10 md:gap-28">
        <img src={maskicon} className="h-24 w-24" />
        <img src={handwashicon} className="h-24 w-24" />
        <img src={alcogelicon} className="h-24 w-24" />
      </div>
    </div>
  );
}

export default CovidGuideLines
